import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

import listingReducer from './listing';
import messagesReducer from './messages';
import ListingsCountersReducer from './listingsCounters';
import ParentsInfoOkReducer from './listingParentsInfoOk';
import PuppyInfoOkReducer from './listingPuppyInfoOk';
import LitterInfoOkReducer from './listingLitterInfoOk';
import listingFileUploadReducer from './listingFileUpload';
import mediaEditorReducer from './mediaEditor';
import baseLayoutSettingsReducer from 'store/baseLayoutSettings/baseLayoutSettingsReducer';
import listingsSearchParamsReducer from 'store/listingsSearchParams/listingsSearchParamsReducer';
import workCardsReducer from 'store/workCards/workCardsReducer';
import mineReducer from 'store/mine/mineReducer';
import staticContentReducer from 'store/staticContent/staticContentReducer';
import listingHistoryReducer from 'store/listingHistory/listingHistoryReducer';
import breederContractsReducer from 'store/breederContracts/breederContractsReducer';

const rootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    mine: mineReducer,
    workCards: workCardsReducer,
    listingsSearchParams: listingsSearchParamsReducer,
    baseLayoutSettings: baseLayoutSettingsReducer,
    staticContent: staticContentReducer,
    listingHistory: listingHistoryReducer,
    breederContracts: breederContractsReducer,
    listingReducer,
    messagesReducer,
    ListingsCountersReducer,
    ParentsInfoOkReducer,
    PuppyInfoOkReducer,
    LitterInfoOkReducer,
    listingFileUploadReducer,
    mediaEditorReducer,
  });

export default rootReducer;
